if (!customElements.get("back-to-top")) {
  class BackToTop extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector("[data-scroll-to-top-btn]");

      // smooth scroll to top of page
      this.button.addEventListener("click", () =>
        window.scroll({ top: 0, behavior: "smooth" })
      );

      // toggle button visibility on scroll
      window.addEventListener("scroll", () => {
        if (this.button) {
          // show button if scrolled down 100px
          if (window.scrollY > 100) {
            this.button.classList.remove("hidden");
          }

          // if on top of page, hide button
          if (window.scrollY === 0) {
            this.button.classList.add("hidden");
          }
        }
      });
    }
  }

  window.BackToTop = BackToTop;

  customElements.define("back-to-top", BackToTop);
}
